/**
 * Created by baladewa on 9/1/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name createPairing.controller:MissingItemsCtrl
     *
     * @description
     *
     */
    angular
        .module('trainingPrograms')
        .controller('conflictsTrainingsCtrl', conflictsTrainingsCtrl);

    function conflictsTrainingsCtrl($uibModalInstance, modalParams) {
        var vm = this;
        vm.ctrlName = 'conflictsTrainingsCtrl';
        vm.model = {
            conflictsTrainings: modalParams.conflictsTrainings
        };

        vm.clickYes = function(){
            $uibModalInstance.close('YES');
        };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };
    }
}());
